import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useLoggedOutCategoryPageCatNavResponse } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageCatNav/useLoggedOutCategoryPageCatNavResponse";
import { useLoggedOutCategoryPageRequestPageSize } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/hooks/useLoggedOutCategoryPageRequestPageSize";
import { IPaginationData } from "@faire/web-api--source/indigofair/data/IPaginationData";
import { useMemo } from "react";
export var useLoggedOutCategoryPagePaginationData = function() {
    var _useLoggedOutCategoryPageCatNavResponse_data;
    var requestPageSize = useLoggedOutCategoryPageRequestPageSize();
    var paginationData = (_useLoggedOutCategoryPageCatNavResponse_data = useLoggedOutCategoryPageCatNavResponse().data) === null || _useLoggedOutCategoryPageCatNavResponse_data === void 0 ? void 0 : _useLoggedOutCategoryPageCatNavResponse_data.paginationData;
    return useMemo(function() {
        if (paginationData === undefined) {
            return undefined;
        }
        var _paginationData_total_results;
        return IPaginationData.build(_object_spread_props(_object_spread({}, paginationData), {
            page_size: requestPageSize,
            page_count: Math.ceil(((_paginationData_total_results = paginationData.total_results) !== null && _paginationData_total_results !== void 0 ? _paginationData_total_results : 0) / requestPageSize)
        }));
    }, [
        paginationData,
        requestPageSize
    ]);
};
